import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ppl-error-box',
    templateUrl: './error-box.component.html',
    styleUrls: ['./error-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
